import React from 'react';
import { SnuggesListicle } from './pages/SnuggesListicle';
export function App() {
  return <SnuggesListicle data-id="element-0" />;
}